import { useTranslation } from 'react-i18next';

import { Checkbox } from '@/components/ui/checkbox';
import { Label } from '@/components/ui/label';

import { MAP_LAYERS } from '../lib/map-layers.config';
import { MAP_LAYER_IDS, type MapLayerId } from '../model/types';

interface MapLayersControlProps {
  activeLayers: MapLayerId[];
  onToggle: (id: MapLayerId) => void;
}

export function MapLayersControl({ activeLayers, onToggle }: MapLayersControlProps) {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col gap-1.5">
      {MAP_LAYER_IDS.map((id) => (
        <div key={id} className="flex items-center gap-2">
          <Checkbox id={`map-layer-${id}`} checked={activeLayers.includes(id)} onCheckedChange={() => onToggle(id)} />
          <Label htmlFor={`map-layer-${id}`} className="cursor-pointer text-xs font-normal">
            {t(MAP_LAYERS[id].labelKey)}
          </Label>
        </div>
      ))}
    </div>
  );
}
